<template>
    <el-dialog
        title="请选择您的科目"
        :visible.sync="dialogVisible"
        width="700px"
        >
        <div>
            <el-cascader-panel ref="cascader" v-model="identity_id" :options="identityIds" :props="{ value: 'identity_id',label:'title' }" @change="getIdentityName"></el-cascader-panel>
        </div>
        <span slot="footer" class="dialog-footer">
        </span>
    </el-dialog>
</template>

<script>
export default {
    data(){
        return{
            dialogVisible:false,
            identity_id:[],
            identityIds:[]
        }
    },
    watch:{
        identity_id:{
            handler(val,old){
                if(val.length>0 && old.length>0){
                    this.$emit('update',val)
                    this.dialogVisible = false;
                }
            }
        }
    },
    methods:{
        getIdentityName(value){
            const checkedNodes = this.$refs.cascader.getCheckedNodes();
            const labels = checkedNodes.map(node => node.label);
            this.$store.dispatch('app/setIdentityName', labels[labels.length-1])
        },
        open(identity_id,identityIds){
            this.identity_id = identity_id;
            this.identityIds = identityIds;
            this.dialogVisible = true;
        }
    },

}
</script>

<style scoped>
::v-deep .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #FF7D00;
}
::v-deep .el-cascader-panel .el-cascader-node.is-active {
    color: #FF7D00;
}
</style>
